<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header" class="login-header">
        <span>SSO 登录系统</span>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="rules"
        label-width="0"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model.trim="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model.trim="loginForm.password"
            type="password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            style="width: 100%"
            @click="handleLogin"
          >
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '../api/auth';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: { username: '', password: '' },
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          const { data, headers } = await login(this.loginForm);
          // 后端将 token 放在响应头 Authorization 中
          const authHeader = headers['authorization'] || '';
          // 后端返回格式 "Bearer <token>"，只存储纯 token
          const token = authHeader.replace(/^Bearer\s+/i, '');
          if (token) {
            localStorage.setItem('sso_token', token);
            localStorage.setItem('sso_user', data.data.username);
            localStorage.setItem('sso_role', data.data.role);
          }
          this.$message.success(data.message || '登录成功');
          const returnUrl = this.$route.query.returnUrl;
          if(returnUrl){
            this.$router.replace(returnUrl);
          } else {
            this.$router.push('/dashboard');
          }          
        } catch (err) {
          this.$message.error(err.message || '登录失败');
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.login-card {
  width: 400px;
  border-radius: 8px;
}
.login-header {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}
.login-tip {
  text-align: center;
  color: #909399;
  font-size: 12px;
  margin: 0;
}
</style>